<template>
  <div>
    <br />
    <GmapMap
      :center="{ lat: +user.latitude, lng: +user.longitude }"
      :zoom="12"
      style="width:100%;  height: 400px;"
    >
      <GmapMarker
        :position="{ lat: +user.latitude, lng: +user.longitude }"
        :clickable="true"
        :label="user.name"
        :draggable="true"
      />
    </GmapMap>
  </div>
</template>
<script>
export default {
  name: "GoogleMap",
  data() {
    return {
      user: {
        latitude: "",
        longitude: "",
        name: "",
      },
    };
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
  },
};
</script>
